import { render, staticRenderFns } from "./CandidateSignIn.vue?vue&type=template&id=0b54cfea&"
import script from "./CandidateSignIn.vue?vue&type=script&lang=js&"
export * from "./CandidateSignIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports